import BaseApplication from "./base.js";

import $ from "jquery";
import datepicker from "@chenfengyuan/datepicker";
import "@chenfengyuan/datepicker/i18n/datepicker.ja-JP.js";

import swal from "sweetalert";
import IMask from "imask";

("use strict");

export default class BaseContact extends BaseApplication {
    constructor(args = []) {
        super(args);
        this.setLog("[Extension] ", "Contact Application");
    }

    setForms() {
        const self = this;
        this.form = document.getElementById(this.contact.id);
        if (
            !this.isEmpty(this.form) &&
            !this.isEmpty(this.form.getAttribute("id"))
        ) {
            this.bindForm(
                this.form,
                this.contact.route + this.form.getAttribute("id")
            );
        }
    }

    bindForm(targetForm, targetRoute) {
        const self = this;
        this.formStatus = {
            currentStep: "form",
        };

        if (typeof self.contact.confirmation !== "undefined") {
            console.log("With COnfirmation", self.formStatus.currentStep);

            const resetStatusButton = this.form.querySelector("[reset-status]");
            if (resetStatusButton) {
                resetStatusButton.addEventListener("click", (event) => {
                    event.preventDefault();
                    if (self.formStatus.currentStep === "confirmation") {
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "smooth",
                        });
                        setFormStatus("form");
                    }
                });
            }
        } else {
            console.log("No confirmation");
        }

        const lockFormFields = (status) => {
            const formFields = this.form.querySelectorAll(
                ".form-container input, .form-container select, .form-container button, .form-container textarea"
            );
            for (let i = 0; i < formFields.length; i++) {
                const formField = formFields[i];
                if (status === true) {
                    formField.setAttribute("disabled", true);
                } else {
                    formField.removeAttribute("disabled");
                }
            }
        };

        const setFormStatus = (status) => {
            switch (status) {
                case "confirmation":
                    console.log("Set as CONFIRMATION");
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: "smooth",
                    });
                    self.form.classList.add("is-confirmation");
                    self.formStatus.currentStep = "confirmation";
                    lockFormFields(true);
                    break;
                default:
                    self.form.classList.remove("is-confirmation");
                    self.formStatus.currentStep = "form";
                    lockFormFields(false);
                    break;
            }
        };

        this.form.addEventListener("submit", function (event) {
            event.preventDefault();
            if (typeof self.contact.confirmation !== "undefined") {
                switch (self.formStatus.currentStep) {
                    case "confirmation":
                        setFormStatus("form");
                        sendForm(self.form);
                        break;

                    case "form":
                        setFormStatus("confirmation");
                        break;

                    default:
                        setFormStatus("form");
                        break;
                }
            } else {
                sendForm(self.form);
            }
        });

        const inputMaskList = this.form.querySelectorAll("[data-mask]");
        if (!this.isEmpty(inputMaskList)) {
            [].forEach.call(inputMaskList, function (inputMask) {
                var maskPattern = inputMask.getAttribute("data-mask");
                if (!self.isEmpty(maskPattern)) {
                    IMask(inputMask, {
                        mask: maskPattern,
                    });
                }
            });
        }

        this.setDateFields();

        const conditionalInputs = this.form.querySelectorAll("[data-if]");
        if (!this.isEmpty(conditionalInputs)) {
            [].forEach.call(conditionalInputs, function (conditionalInput) {
                var ifConditions = JSON.parse(
                    conditionalInput.getAttribute("data-if")
                );
                var elseConditions = JSON.parse(
                    conditionalInput.getAttribute("data-else")
                );
                for (var key in ifConditions) {
                    var target = document.getElementById(key);
                    var conditionAction = function (conditionMatch, target) {};
                    if (!self.isEmpty(elseConditions)) {
                        conditionAction = function (conditionMatch, target) {
                            // var actionTarget = target.parentNode.parentNode;
                            var actionTarget = target.parentNode;
                            if (actionTarget.tagName === "TD") {
                                actionTarget = actionTarget.parentNode;
                            }

                            if (!self.isEmpty(elseConditions["hide"])) {
                            }
                            {
                                if (elseConditions["hide"] == conditionMatch) {
                                    actionTarget.classList.remove("null");
                                } else {
                                    actionTarget.classList.add("null");
                                    target.value = null;
                                }
                            }
                        };
                    }
                    var conditionTrigger = function () {
                        conditionAction(
                            self.form.elements[key].value == ifConditions[key],
                            conditionalInput
                        );
                    };

                    target.addEventListener("change", conditionTrigger);
                    conditionTrigger();
                }
            });
        }

        const toggleDisplayElements =
            this.form.querySelectorAll("[toggle-display]");
        if (toggleDisplayElements) {
            const toggleDisplay = (element, toggle) => {
                toggle
                    ? element.classList.remove("null")
                    : element.classList.add("null");

                if (element.tagName === "fieldset") {
                    element.reset();
                }
            };

            const toggleParentCascade = (elements, targetValue) => {
                for (let i = 0; i < elements.length; i++) {
                    const element = elements[i];
                    const fieldElement = element.querySelector("input");
                    if (fieldElement) {
                        const targetCriteria =
                            fieldElement.getAttribute("toggle-display");
                        const targetElement =
                            document.getElementById(targetCriteria);

                        if (targetElement) {
                            toggleDisplay(
                                targetElement,
                                targetCriteria === targetValue
                            );
                        }
                    }
                }
            };

            const getParentFieldset = (target) => {
                let targetParent = target.parentNode;
                if (targetParent.parentNode.tagName === "FIELDSET") {
                    targetParent = targetParent.parentNode;
                }
                return targetParent;
            };

            for (let i = 0; i < toggleDisplayElements.length; i++) {
                const toggleDisplayElement = toggleDisplayElements[i];
                const targetCriteria =
                    toggleDisplayElement.getAttribute("toggle-display");
                const targetElement = document.getElementById(targetCriteria);

                if (targetElement) {
                    toggleDisplayElement.addEventListener("change", (event) => {
                        if (event.target) {
                            toggleDisplay(targetElement, event.target.checked);
                            if (event.target.hasAttribute("toggle-parent")) {
                                const targetParent = getParentFieldset(
                                    event.target
                                );

                                toggleParentCascade(
                                    targetParent.childNodes,
                                    targetCriteria
                                );
                            }
                        }
                    });

                    if (toggleDisplayElement.hasAttribute("toggle-parent")) {
                        const targetParent =
                            getParentFieldset(toggleDisplayElement);
                        toggleParentCascade(
                            targetParent.childNodes,
                            toggleDisplayElement.checked ? targetCriteria : null
                        );
                    } else {
                        toggleDisplay(
                            targetElement,
                            toggleDisplayElement.checked
                        );
                    }
                }
            }
        }

        function setLoader(status) {
            if (status) {
                self.isSending = true;
                targetForm.classList.add("isLoading");
                targetForm.classList.remove("isDone");
            } else {
                self.isSending = false;
                targetForm.classList.remove("isLoading");
                targetForm.classList.add("isDone");
            }
        }

        function sendForm(formEvent) {
            if (self.isSending) {
                return;
            }
            setLoader(true);

            var errorFields = formEvent.getElementsByClassName("field-errors");
            while (errorFields[0]) {
                errorFields[0].previousElementSibling.classList.remove(
                    "has-error"
                );
                errorFields[0].parentNode.removeChild(errorFields[0]);
            }

            self.ajax({
                method: "POST",
                route: targetRoute,
                responseType: "json",
                data: new FormData(formEvent),
                complete: function (xhr, data) {
                    setLoader(false);
                },
                success: function (xhr, data) {
                    var response = data.response;
                    if (typeof response != "object") {
                        response = JSON.parse(response);
                    }
                    if (!self.isEmpty(response)) {
                        if (response !== true && typeof response == "object") {
                            var responseTarget = document.getElementById(
                                response.form
                            );
                            if (!self.isEmpty(responseTarget)) {
                                if (!self.isEmpty(response.error)) {
                                    throwFormError(response);
                                }

                                for (var key in response.fields) {
                                    if (response.fields.hasOwnProperty(key)) {
                                        var field = {
                                            name: key,
                                            element:
                                                document.getElementById(key),
                                            data: response.fields[key],
                                        };
                                        if (
                                            !self.isEmpty(field.element) &&
                                            key != "_token"
                                        ) {
                                            field.element.classList.add(
                                                "has-error"
                                            );
                                            var errorList =
                                                document.createElement("ul");
                                            errorList.classList.add(
                                                "field-errors"
                                            );

                                            [].forEach.call(
                                                field.data.errors,
                                                function (error) {
                                                    var errorItem =
                                                        document.createElement(
                                                            "li"
                                                        );
                                                    errorItem.innerText = error;
                                                    errorList.appendChild(
                                                        errorItem
                                                    );
                                                }
                                            );

                                            field.element.parentNode.appendChild(
                                                errorList
                                            );
                                        } else {
                                            self.throwFormError(
                                                field.data.errors.join(", ")
                                            );
                                        }
                                    }
                                }

                                var firstErrorElement =
                                    responseTarget.getElementsByClassName(
                                        "has-error"
                                    )[0];
                                if (!self.isEmpty(firstErrorElement)) {
                                    self.scrollToElement(firstErrorElement);
                                }
                            } else {
                                self.throwFormError(response);
                            }
                        } else {
                            formEvent.reset();
                            self.formComplete(formEvent, response);
                        }
                    } else {
                        self.throwFormError(data);
                    }
                },
                error: function (xhr, data) {
                    self.throwFormError(data);
                },
            });
        }
    }

    setDateFields() {
        $(".date-picker").datepicker({
            language: "ja-JP",
        });
    }

    formComplete(form, response) {
        this.scrollToElement(form, function () {
            swal({
                title: "OK",
                text: "送信完了",
                icon: "success",
            });
        });
    }

    throwFormError(data) {
        var errorMessage = data.error;
        if (!this.isEmpty(errorMessage)) {
            swal({ title: "エラー", text: errorMessage, icon: "error" });
        } else {
            swal({ title: "エラー", text: data, icon: "error" });
        }
    }
}
